// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle_switch__zJSXX","slider":"Toggle_slider__m9n3b","round":"Toggle_round__67dcA"};